<template>
  <div v-if="policy != null">
    <div class="block mb-5">
      <!-- ID -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5"><h4>ID</h4></div>
        <div class="flex-grow-1 flew-basis-0 my-n2">
          <div class="w-248px mr-5 support-policy-autocomplete">
            <input type="text" disabled :value="policy.id" />
          </div>
          <div class="ml-10px ink-02-medium--text h5">(自動生成)</div>
        </div>
      </div>
      <!-- Bu -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5"><h4>Bu</h4></div>
        <div class="flex-grow-1 flew-basis-0 my-n2">
          <div class="w-248px mr-5 support-policy-autocomplete">
            <v-autocomplete
              v-model="policy.bu_id"
              :items="buTabs"
              placeholder="請選擇所屬BU"
              item-text="name"
              item-value="id"
              outlined
              dense
            >
            </v-autocomplete>
          </div>
        </div>
      </div>
      <!-- 選擇分類 -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>Category</h4>
          <div class="h5 ink-02-medium--text">
            空值代表全產品分類
          </div>
        </div>
        <div class="flex-grow-1 flew-basis-0 my-n2">
          <div class="w-248px mr-5 support-policy-autocomplete">
            <v-autocomplete
              :items="categories"
              v-model="policy.product_category_id"
              placeholder="請選擇產品分類"
              item-value="id"
              item-text="name"
              outlined
              dense
            >
            </v-autocomplete>
          </div>
        </div>
      </div>
      <!-- SubCategory -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5"><h4>SubCategory</h4></div>
        <div class="flex-grow-1 flew-basis-0 my-n2">
          <div class="w-248px mr-5 product-policy-autocomplete">
            <v-autocomplete
              v-model="policy.product_sub_category_id"
              :items="subcategories"
              placeholder="請選擇所屬SubCategory"
              item-text="name"
              item-value="id"
              outlined
              dense
            >
            </v-autocomplete>
          </div>
        </div>
      </div>
      <!-- Model Name -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5"><h4>Model Name</h4></div>
        <div class="flex-grow-1 flew-basis-0 my-n2 d-flex mr-5">
          <div class="w-480px mr-5 support-policy-autocomplete">
            <MultiSelectWithCheckbox
                v-model="policy.product_ids"
                :items="products"
                placeholder="請選擇產品型號"
                item-text="model_name"
                item-value="id"
              >
            </MultiSelectWithCheckbox>
          </div>
        </div>
      </div>
      <!-- Title -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>Title</h4>
          <div class="h5 ink-02-medium--text">
            會出現在前台頁面
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="policy.title"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
      <!-- Keyword -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>Keyword</h4>
          <div class="h5 ink-02-medium--text">
            僅在後台出現, 供管理者辨識用
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="policy.keyword"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
      <!-- 顯示/隱藏 -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>顯示/隱藏</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <FormSwitch v-model="policy.status"></FormSwitch>
        </div>
      </div>
      <!-- Popular Warranty Policy -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>General Warranty Policy</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <FormSwitch v-model="policy.popularYN"></FormSwitch>
        </div>
      </div>
      <!-- Order -->
      <div class="form-item d-flex py-5">
        <div class="w-220px mr-8">
          <h4 class="mb-10px">Order</h4>
          <div class="h5 ink-02-medium--text">
            資料降冪排序(數字越大顯示越前面)
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="policy.order"
            placeholder="請輸入序號"
            class="w-248px"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
    </div>
    <!-- TextEditor -->
    <editor
      v-model="policy.content"
      :height="600"
      :plugins="'link image lists'"
      :toolbar="'link|fontsize select|image'"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Editor from '@/components/TinymceEditor.vue';
import MultiSelectWithCheckbox from '@/components/Selection/MultiSelectWithCheckbox.vue';
import FormSwitch from '@/components/FormSwitch.vue';

export default {
  components: {
    MultiSelectWithCheckbox,
    Editor,
    FormSwitch,
  },
  data: () => ({
    categories: [],
    subcategories: [],
    products: [],
  }),
  computed: {
    ...mapState(['buTabs']),
    ...mapState('language', ['languages']),
    ...mapState('supportWarrantyPolicy', ['policy']),
  },
  watch: {
    async 'policy.bu_id'() {
      this.categories = await this.allByBu(this.policy.bu_id);
    },
    async 'policy.product_category_id'() {
      this.subcategories = await this.getSubCategories(this.policy.product_category_id);
    },
    async 'policy.product_sub_category_id'() {
      this.products = await this.getProducts(this.policy.product_sub_category_id);
    },
  },
  methods: {
    ...mapActions('category', ['allByBu']),
    ...mapActions('supportWarrantyPolicy', {
      getSubCategories: 'allByCategory',
    }),
    ...mapActions('supportWarrantyPolicy', {
      getProducts: 'allBySubCateogry',
    }),
    /* selectCategory(id) {
      const category = this.categories.find((item) => item.id === id);
      if (category) {
        return category.products;
      }
      return [];
    }, */
  },
};
</script>
<style lang="scss">
.support-policy-autocomplete {
  .v-autocomplete {
    .v-input__slot {
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
    .v-text-field__details {
      display: none;
    }
  }

  // border
  fieldset {
    border-color: #d7dee7;
    border-radius: 8px;
  }
  .v-input--is-focused {
    border-color: $brand-500;
  }

  // placeholder color
  input::placeholder {
    color: #848fa0 !important;
  }
}
</style>
